import { CircularProgress } from '@mui/material'
import React from 'react'

function CircularProgressBar() {
    return (
        <div>
            <CircularProgress  disableShrink   /> 
        </div>
    )
}

export default CircularProgressBar
